import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { withParams } from '@sl/sl-angular-library';
import { Observable } from "rxjs";
import { ILeadershipPosition } from "src/app/shared/models/leadership-position.model";
import { IOffer } from "src/app/shared/models/offer.model";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
  })
  export class OfferRepository {
  
    private readonly offersUrl: string = `${environment.apiUrl}/offers`;
  
    constructor(private http: HttpClient) { }

    public getPendingOffersByApplication(applicationId: number): Observable<Array<IOffer>> {
      return this.http.get<Array<IOffer>>(`${this.offersUrl}/pending/application`, withParams({applicationId}));
    }

    public getPendingOffersByStudent(pidm: number): Observable<Array<IOffer>> {
      return this.http.get<Array<IOffer>>(`${this.offersUrl}/pending/student`, withParams({pidm}));
    }

    public getAllActiveOffersCount(): Observable<number> {
      return this.http.get<number>(`${this.offersUrl}/all-active-offers-count`);
    }

    public acceptOffer(offerId: number): Observable<ILeadershipPosition> {
      return this.http.put<ILeadershipPosition>( `${this.offersUrl}/${offerId}/accept`, null);
    }

  }